var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftBackgroundLines2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 228,
    viewBox: "0 0 128 228",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.5215 262.613V181.127C27.5215 176.043 23.4004 171.922 18.3167 171.922H-28.9844C-33.7504 171.922 -37.614 168.058 -37.614 163.292V79.4373C-37.614 74.3536 -41.7351 70.2324 -46.8188 70.2324L-75 70.2325",
    stroke: "url(#paint0_linear_1238_92482)",
    strokeWidth: 0.345576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-50.9014 114.753L-13.9204 114.753C-9.15445 114.753 -5.29086 118.617 -5.29086 123.382V196.391C-5.29086 201.157 -1.42727 205.021 3.3387 205.021H125.55",
    stroke: "url(#paint1_linear_1238_92482)",
    strokeWidth: 0.345576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.553 0.386719V57.5701H27.5242V9.59158C27.5242 4.50787 23.4031 0.386719 18.3194 0.386719H-37.8281",
    stroke: "url(#paint2_linear_1238_92482)",
    strokeWidth: 0.345576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.552 115.162H101.506C96.7396 115.162 92.876 111.298 92.876 106.532V0.386719",
    stroke: "url(#paint3_linear_1238_92482)",
    strokeWidth: 0.345576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-35.3809 52.2607H-2.67742V100.746C-2.67742 105.512 1.18616 109.376 5.95214 109.376H62.7295V166.219H128",
    stroke: "url(#paint4_linear_1238_92482)",
    strokeWidth: 0.345576
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1238_92482",
    x1: 36.4733,
    y1: 246.912,
    x2: -61.5783,
    y2: 56.8021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375941,
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727934,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1238_92482",
    x1: 140.957,
    y1: 197.654,
    x2: 125.386,
    y2: 86.9119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375941,
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727934,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1238_92482",
    x1: 139.819,
    y1: 52.903,
    x2: 133,
    y2: -17.9812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375941,
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727934,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1238_92482",
    x1: 128.405,
    y1: 105.794,
    x2: 56.6541,
    y2: 31.4736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375941,
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727934,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1238_92482",
    x1: 142.266,
    y1: 156.918,
    x2: 115.903,
    y2: 19.403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375941,
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727934,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.6
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftBackgroundLines2);
export default __webpack_public_path__ + "static/media/left-backgroundLines2.4944223d42872ce02941572edea7ae21.svg";
export { ForwardRef as ReactComponent };